// import mixpanel from 'mixpanel-browser'; // No more needed as of now - Mixpanel tracking disabled (use this version only - "mixpanel-browser": "^2.47.0",)
import { isCuratorPage } from '../helpers/urlHelper';
import { LF_DEBUGGER_EVENT_TRACKING } from '../config/constant/projectConstant';
import { CURRENT_USER, EG_SUBMISSION } from '../constants/projectConstants';
import { enableDebugging } from '../helpers/logEvents';
import { Userpilot } from 'userpilot';
import {
  CURATOR_OPEN_SOURCE,
  IS_SHARED,
  OPEN_IMAGES,
  UP_FILE_NAME,
  UP_HOTSPOT_NAME,
  UP_IS_EXPAND,
  UP_MAIN_ORIGIN,
  UP_MODEL_ID,
  UP_MODEL_NAME,
  UP_RENDER_ID,
  UP_UPLOAD_EXTENSION,
  UP_UPLOAD_TYPE,
  USERPILOT_UUID,
} from '../constants/constants';
import { getLocalStorage, getOrGenerateEpochUUID, getUserTimezone } from '../helpers/jsHelper';
import { getCurrentDeviceInfo } from '../helpers/segmentHelper';

// No more needed as of now - Mixpanel tracking disabled (re-enable by restoring the import above and removing this stub) - (use this version only - "mixpanel-browser": "^2.47.0",)
const mixpanel = {
  init: () => {},
  identify: () => {},
  alias: () => {},
  track: () => {},
  people: { set: () => {} },
  reset: () => {},
  register: () => {},
};

const USERPILOT_PRODUCTION_TOKEN = 'NX-7dee3a76';
const USERPILOT_STAGING_TOKEN = 'STG-NX-7dee3a76';

export const getUserpilotEventKeysForCurator = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const data = {
    [UP_RENDER_ID]: searchParams.get(UP_RENDER_ID),
    [UP_IS_EXPAND]: searchParams.get(UP_IS_EXPAND) === 'Yes' ? 'Yes' : 'No',
    [UP_MODEL_ID]: searchParams.get(UP_MODEL_ID),
    [UP_MODEL_NAME]: searchParams.get(UP_MODEL_NAME),
    [UP_UPLOAD_TYPE]: searchParams.get(UP_UPLOAD_TYPE),
    [UP_UPLOAD_EXTENSION]: searchParams.get(UP_UPLOAD_EXTENSION),
    [UP_FILE_NAME]: searchParams.get(UP_FILE_NAME),
    [UP_HOTSPOT_NAME]: searchParams.get(UP_HOTSPOT_NAME),
    [UP_MAIN_ORIGIN]: searchParams.get(UP_MAIN_ORIGIN) || getLocalStorage(UP_MAIN_ORIGIN),
  };
  return Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== null && value !== undefined)
  );
};

// getBasicUserDetails: this is used for userpilot only
// and, it is also available in different file but we are unable to use it.
// So, do not remove this function from here
// Note: If you add new keys here, also update it in the getBasicUserDetails in the userpilotHelper.js
const getBasicUserDetails = () => {
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const searchParams = new URLSearchParams(window.location.search);

  const deviceInfo = Object.entries(getCurrentDeviceInfo()).reduce((acc, [key, value]) => {
    acc[key.toLowerCase()] = value;
    return acc;
  }, {});

  return {
    // user_id: currentUser?.user_pilot_id || localStorage.getItem(USERPILOT_UUID),
    imagine_id: currentUser?.user?.id,
    member_id: currentUser?.user?.member_id,
    email: currentUser?.user?.email || getLocalStorage(EG_SUBMISSION),
    created_at: currentUser?.user?.userRegisteredOn,
    is_guest_user: currentUser?.is_guest ? 'Yes' : 'No',
    page_url: window.location.href,
    page_title: document.title,
    is_remove_watermark: searchParams?.get(OPEN_IMAGES) === 'true' ? 'Yes' : 'No',
    is_shared_experience: searchParams?.get(IS_SHARED) ? 'Yes' : 'No',
    curator_open_source: searchParams?.get(CURATOR_OPEN_SOURCE), // 'Catalog, Model upload, Texture upload, Templates, Example edit',
    is_gamified_onboarding: searchParams?.get('isOnboarding') === 'true' ? 'Yes' : 'No',
    is_website: false,
    time_stamp: Math.floor(Date.now() / 1000),
    page_source: document.title,
    utm_source: searchParams?.get('utm_source'),
    utm_campaign: searchParams?.get('utm_campaign'),
    utm_medium: searchParams?.get('utm_medium'),
    utm_content: searchParams?.get('utm_content'),
    utm_term: searchParams?.get('utm_term'),
    is_test_user: localStorage.getItem(LF_DEBUGGER_EVENT_TRACKING) === 'true' ? 'Yes' : 'No',
    full_name: currentUser?.user?.name,
    current_org_id: currentUser?.organization_detail?.id,
    current_org_name: currentUser?.organization_detail?.name,
    current_org_subscription_type: currentUser?.organization_detail?.subscription_type,
    current_org_subscription_status_id: currentUser?.organization_detail?.status?.id,
    current_org_subscription_status_name: currentUser?.organization_detail?.status?.name,
    was_guest_user: currentUser?.was_guest_user ? 'Yes' : 'No',

    ...getUserpilotEventKeysForCurator(),

    ...(deviceInfo || {}),

    ip_location: '',

    timezone: getUserTimezone(),
  };
};

export const RESTRICTED_EMAIL_DOMAIN = [
  'imagine.io',
  'livefurnish.com',
  'taglineinfotech.com',
  'algoworks.com',
];
const isDebugTrackingEnabled = () => localStorage.getItem(LF_DEBUGGER_EVENT_TRACKING) === 'true';

const logMixPanel = isDebugTrackingEnabled() ? true : false;

export function LogMixPanel(...value) {
  if (logMixPanel) {
    console.log('DEBUG__mx: ', ...value);
  }
}

const CURRENT_URL = window.location.href;
export const isProductionUrl = CURRENT_URL.includes('//app.imagine.io');

/**
 * Determines whether the current user should be tracked.
 *
 * The function checks the following conditions:
 * 1. If the current URL is a production URL and debug tracking is not enabled, it checks if the user's email domain is not in the `RESTRICTED_EMAIL_DOMAIN` list.
 * 2. If debug tracking is enabled, the function returns `true` regardless of the other conditions.
 *
 * @returns {boolean} `true` if the current user should be tracked, `false` otherwise.
 */
// export const shouldTrackUser = (userEmail = null) => {
//   if (isDebugTrackingEnabled()) {
//     return true;
//   }

//   const getLoggedinUserEmail = () => {
//     if (userEmail) return userEmail;

//     return localStorage.getItem(CURRENT_USER)
//       ? JSON.parse(localStorage.getItem(CURRENT_USER))?.user?.email
//       : localStorage.getItem(EG_SUBMISSION) || null;
//   };

//   const email = getLoggedinUserEmail();

//   if (email && RESTRICTED_EMAIL_DOMAIN.some((domain) => email.includes(domain))) {
//     return false;
//   }

//   const _shouldTrackUser = (isProductionUrl && !isDebugTrackingEnabled());

//   // const trackAllowedEmailDomains = !RESTRICTED_EMAIL_DOMAIN.some((domain) =>
//   //   getLoggedinUserEmail()?.includes(domain)
//   // );

//   // const _shouldTrackUser =
//   //   (isProductionUrl && !isDebugTrackingEnabled() && trackAllowedEmailDomains) ||
//   //   isDebugTrackingEnabled();

//   return _shouldTrackUser;
// };

export const shouldTrackUser = (userEmail = null) => {
  // Always allow if debug mode
  if (isDebugTrackingEnabled()) return true;

  // Resolve user email only once
  let email = userEmail;
  if (!email) {
    const currentUser = localStorage.getItem(CURRENT_USER);
    if (currentUser) {
      email = JSON.parse(currentUser)?.user?.email || null;
    } else {
      email = localStorage.getItem(EG_SUBMISSION) || null;
    }
  }

  // Block restricted domains
  if (email && RESTRICTED_EMAIL_DOMAIN.some(domain => email.includes(domain))) {
    return false;
  }

  // Allow only in production and when not debugging
  return isProductionUrl;
};


async function initializeMixpanel() {
  // LogMixPanel('DEBUG__mx: initializeMixpanel');
  await enableDebugging();
}

// Example usage:
initializeMixpanel()
  .then(() => {
    if (isProductionUrl && shouldTrackUser()) {
      // LogMixPanel('DEBUG__mx: ', 'environment = production');
      mixpanel.init('847293cb6f5507d5d4e171f17273eb4b');
    } else if (shouldTrackUser()) {
      //LogMixPanel('DEBUG__mx: ', 'environment = staging');
      mixpanel.init('74533e85844ead6a5ef381d6198530ce');
    } else {
      // LogMixPanel('DEBUG__mx: ', 'Mixpanel initialization failed.');
    }
  })
  .catch((error) => {
    // Handle error during Mixpanel initialization
    console.error(error);
  });

function getCommonDetails() {
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const searchParams = new URLSearchParams(window.location.search);

  const deviceInfo = Object.entries(getCurrentDeviceInfo()).reduce((acc, [key, value]) => {
    acc[key.toLowerCase()] = value;
    return acc;
  }, {});

  let CommonDetails = {
    event_origin_page: window?.location?.pathname,
    distinct_id: currentUser?.user?.id,
    $email: currentUser?.user?.email || getLocalStorage(EG_SUBMISSION),
    $first_name: currentUser?.user?.first_name,
    $last_name: currentUser?.user?.last_name,
    full_name: currentUser?.user?.name,
    current_org_id: currentUser?.organization_detail?.id,
    current_org_name: currentUser?.organization_detail?.name,
    current_org_subscription_type: currentUser?.organization_detail?.subscription_type,
    current_org_subscription_status_id: currentUser?.organization_detail?.status?.id,
    current_org_subscription_status_name: currentUser?.organization_detail?.status?.name,
    is_guest_user: currentUser?.is_guest ? 'Yes' : 'No',
    is_website: false,
    is_test_user: localStorage.getItem(LF_DEBUGGER_EVENT_TRACKING) === 'true' ? 'Yes' : 'No',
    time_stamp: Math.floor(Date.now() / 1000),
    utm_source: searchParams?.get('utm_source'),
    utm_campaign: searchParams?.get('utm_campaign'),
    utm_medium: searchParams?.get('utm_medium'),
    utm_content: searchParams?.get('utm_content'),
    utm_term: searchParams?.get('utm_term'),

    ...(deviceInfo || {}),

    ip_location: '',

    timezone: getUserTimezone(),
  };
  let type = null;
  let projectId = null;
  let renderId = null;
  let cameraName = null;
  let temaplateId = null;
  let automationId = null;
  if (isCuratorPage()) {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('renderId')) {
      type = 'Render';
      renderId = new URLSearchParams(new URL(CURRENT_URL).search).get('renderId');
      cameraName = new URLSearchParams(new URL(CURRENT_URL).search).get('cameraName');
      {
        CommonDetails = {
          ...CommonDetails,
          'Curator opened render Id': renderId,
          'Curator opened camera name': cameraName,
          'Curator opened from': type,
        };
      }
    } else if (window.location.pathname.includes('project')) {
      type = 'Project';
      projectId = window.location.pathname.match(/project\/(\d+)/)[1];
      {
        CommonDetails = {
          ...CommonDetails,
          'Curator opened project Id': projectId,
          'Curator opened from': type,
        };
      }
    } else if (searchParams.get('automationId')) {
      type = 'Automation';
      automationId = new URLSearchParams(new URL(CURRENT_URL).search).get('automationId');
      {
        CommonDetails = {
          ...CommonDetails,
          'Curator opened automation Id': automationId,
          'Curator opened from': type,
        };
      }
    } else if (window.location.pathname.includes('room')) {
      type = 'Template';
      const matchParam = window.location.pathname.match(/room\/(\d+)/);
      if (matchParam?.length) {
        temaplateId = window.location.pathname.match(/room\/(\d+)/)[1];
        cameraName = new URLSearchParams(new URL(CURRENT_URL).search).get('cameraName');
        {
          CommonDetails = {
            ...CommonDetails,
            'Curator opened camera name': cameraName,
            'Curator opened temaplate Id': temaplateId,
            'Curator opened from': type,
          };
        }
      }
    }
  }

  return CommonDetails;
}

export const Mixpanel = {
  identify: (id) => {
    if (shouldTrackUser()) mixpanel.identify(id);
    if (shouldTrackUser()) { // removed '!isProductionUrl'
      const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));

      if(currentUser || localStorage.getItem(EG_SUBMISSION)) {
        Userpilot.initialize(isProductionUrl ? USERPILOT_PRODUCTION_TOKEN : USERPILOT_STAGING_TOKEN); // rachit@imagine.io account

        Userpilot.identify(
          currentUser?.user_pilot_id || getOrGenerateEpochUUID(),
          getBasicUserDetails()
        );
      }
    }
  },
  alias: (id) => {
    if (shouldTrackUser()) mixpanel.alias(id);
  },
  track: (isCommonDetails, name, props) => {
    if (shouldTrackUser()) {
      let CommonDetails = null;
      if (isCommonDetails) {
        CommonDetails = getCommonDetails();
      }
      let payload = { ...props, ...CommonDetails };

      // By default, we send the user's email under the key "$email" to Mixpanel.
      // However, for email gating on the public product page, the "$email" key may be absent,
      // but the email is available under the "email" key.
      // Therefore, we need to reformat the payload to include the email correctly.
      if (!payload?.['$email'] && 'email' in payload && payload?.['email']) {
        const { email, ...rest } = payload;
        payload = {
          ...rest,
          ['$email']: email,
        };
      }

      try {
        mixpanel.track(name, payload);
        // LogMixPanel('DEBUG__Mixpanel', name, payload);
      } catch (error) {
        console.error('Mixpanel tracking error', error);
      }
    }

    if (shouldTrackUser()) { // removed '!isProductionUrl'
      const userpilotPayload = {
        ...getBasicUserDetails(),
        ...props,
      };
      Userpilot.track(name, userpilotPayload);
      LogMixPanel('DEBUG__Userpilot', name, userpilotPayload);
    }
  },
  people: {
    set: (props) => {
      if (shouldTrackUser()) mixpanel.people.set(props);
    },
  },
  reset: () => {
    if (shouldTrackUser()) mixpanel.reset();
  },
  register: () => {
    if (shouldTrackUser()) mixpanel.register();
  },
};

export const MxEvent = {
  VISITED_LOGIN: 'Visited - Login',
  VISITED_SIGN_UP: 'Visited - Sign Up',
  VISITED_VERIFY: 'Visited - Verify',
  VISITED_ONBOARDING: 'Visited - Onboarding',
  VISITED_FORGOT_PASSWORD: 'Visited - Forgot Password',
  VISITED_TERMS_OF_USE: 'Visited - Terms of use',
  VISITED_PRIVACY_POLICY: 'Visited - Privacy policy',
  VISITED_SLA_AGREEMENT: 'Visited - SLA Agreement',
  VISITED_DASHBOARD: 'Visited - Homepage',
  VISITED_MY_PRODUCTS: 'Visited - My Products',
  VISITED_MY_PROJECTS: 'Visited - My Projects',

  VISITED_IMAGINE_AI: 'Visited - Imagine AI',
  VISITED_RETAIL_AUTOMATION: 'Visited - Retail Automation',
  VISITED_RETAIL_CONFIGURATOR: 'Visited - Retail Configurator',
  VISITED_PRODUCT_CONFIGURATORS: 'Visited - Product Configurators',
  VISITED_PRODUCT_BUILDER: 'Visited - Mattress Builder',
  VISITED_REQUESTS: 'Visited - Requests',
  VISITED_REQUESTS_MODELS: 'Visited - Requests 3D Models',
  VISITED_REQUESTS_PDP: 'Visited - Requests PDP',

  VISITED_AUTOMATION: 'Visited - Automation',
  VISITED_IMAGE: 'Visited - Images',
  VISITED_TEMPLATES: 'Visited - Templates',
  VISITED_PROPS: 'Visited - Props',
  VISITED_COLLECTIONS: 'Visited - Collections',
  VISITED_CONFIGURATORS: 'Visited - Configurators',
  VISITED_MY_TEAM: 'Visited - My team',
  VISITED_SHARED_FILES: 'Visited - Shared files',
  VISITED_SETTINGS: 'Visited - Settings',
  VISITED_TRASH: 'Visited - Trash',
  VISITED_TUTORIALS: 'Visited - Tutorials',
  VISITED_NEW_DESIGN: 'Visited - New design',
  VISITED_INVITE_USER: 'Visited - Invite user',
  VISITED_MY_MODELS: 'Visited - My models',
  VISITED_MY_ROOMS: 'Visited - My rooms',
  VISITED_MY_TEXTURES: 'Visited - My textures',
  VISITED_MY_CUSTOM_MAPS: 'Visited - My custom maps',
  VISITED_INSPIRATIONS: 'Visited - Inspirations',
  VISITED_PRICING: 'Visited - Pricing',
  VISITED_MY_PLANS: 'Visited - My Plans',
  VISITED_MY_MATERIALS: 'Visited - My materials',
  VISITED_SHARED_PRODUCT_PAGES: 'Visited - Shared Product Pages',

  IMAGINE_AI_CLICKED: 'imagine AI - Clicked',

  LOGIN_CLICKED_MANUAL: 'Login manual - Clicked',
  LOGIN_SUCCESS_MANUAL: 'Login manual - Success',
  LOGIN_FAIL_MANUAL: 'Login manual - Failed',
  LOGIN_CLICKED_GOOGLE: 'Login google - Clicked',
  LOGIN_SUCCESS_GOOGLE: 'Login google - Success',
  LOGIN_FAIL_GOOGLE: 'Login google - Failed',
  LOGIN_OUT_SUCCESS: 'Logout - Success',

  SIGN_UP_SUCCESS: 'Sign up - Success',

  ONBOARDING_STEP_CHANGE: 'Onboarding step change',
  ONBOARDING_INDUSTRY: 'Onboarding - Industry added',
  ONBOARDING_INTREST: 'Onboarding - Interest added',
  ONBOARDING_TEAM_SIZE: 'Onboarding - Team size added',
  ONBOARDING_TEAM_NAME: 'Onboarding - Team name added',
  ONBOARDING_NEWSPANEL_SUBSCRIBED: 'Onboarding - Newsletter subscribed',
  ONBOARDING_NEWSPANEL_SKIPPED: 'Onboarding - Newsletter skipped',
  ONBOARDING_COMPLETED: 'Onboarding - Completed',

  GAMIFY_ONBOARDING_STEP_1: 'Gamify onboarding - 1 - Started',
  GAMIFY_ONBOARDING_STEP_2: 'Gamify onboarding - 2 - Curator started',
  GAMIFY_ONBOARDING_STEP_3: 'Gamify onboarding - 3 - Prop replaced',
  GAMIFY_ONBOARDING_STEP_4: 'Gamify onboarding - 4 - Prop texture added',
  GAMIFY_ONBOARDING_STEP_5: 'Gamify onboarding - 5 - Floor/wall texture added',
  GAMIFY_ONBOARDING_STEP_6: 'Gamify onboarding - 6 - Camera angle set',
  GAMIFY_ONBOARDING_STEP_7: 'Gamify onboarding - 7 - Camera saved',
  GAMIFY_ONBOARDING_STEP_8: 'Gamify onboarding - 8 - Image created',
  GAMIFY_ONBOARDING_COMPLETED: 'Gamify onboarding - Completed',
  GAMIFY_ONBOARDING_IMAGE_SHARED: 'Gamify onboarding - Image shared',
  GAMIFY_ONBOARDING_SKIPPED: 'Gamify onboarding - Skipped',
  GAMIFY_ONBOARDING_RESTARTED: 'Gamify onboarding - Restarted',
  GAMIFY_ONBOARDING_RESUMED: 'Gamify onboarding - Resumed',
  GAMIFY_ONBOARDING_RATED: 'Gamify onboarding - Rated',

  CHANGED_ORGANIZATION: 'Changed org - Success',

  OPENED_FEEDBACK_FORM: 'Opened - Feedback form',
  OPENED_CONTACT_SUPPORT_FORM: 'Opened - Contact support form',
  OPENED_VIDEO_FORM: 'Opened - Video form',

  IN_PAGE_SEARCH: 'In page - Search',

  TEAM_MEMBER_VIEWED_DETAILS: 'Team member - Viewed details',
  TEAM_MEMBER_ACTIVATED: 'Team member - Activated',
  TEAM_MEMBER_DEACTIVATED: 'Team member - Deactivated',
  TEAM_MEMBER_ADMIN_ACTIVATED: 'Team member - Admin activated',
  TEAM_MEMBER_ADMIN_DEACTIVATED: 'Team member - Admin deactivated',
  TEAM_MEMBER_PERMISSIONS_CHANGED: 'Team member - Permissions changed',
  TEAM_MEMBER_INVITE_RESEND: 'Team member - Invite resent',
  TEAM_MEMBER_INVITE_DELETED: 'Team member - Invite deleted',
  TEAM_MEMBER_INVITED: 'Team member - Invited',

  NOTIFICATION_PANEL_VIEWED: 'Notifications - Panel viewed',
  NOTIFICATION_ACTION: 'Notifications - Action',

  CURATOR_STARTED: 'Curator - Started',
  CURATOR_CLOSED: 'Curator - Closed',
  CURATOR_CREATE_IMAGE_POPUP_OPEN: 'Curator - Create image popup opened',
  CURATOR_CREATE_IMAGE_POPUP_CLOSED: 'Curator - Create image popup closed',
  CURATOR_LIGHT_EFFECT_ON: 'Curator - light effect on',
  CURATOR_LIGHT_EFFECT_OFF: 'Curator - light effect off',
  CURATOR_FOV_ADJUSTED: 'Curator - FOV adjusted',
  CURATOR_OPENED_PANEL_PRODUCT: 'Curator - Opened product panel',
  CURATOR_OPENED_PANEL_STYLE: 'Curator - Opened style panel',
  CURATOR_OPENED_PANEL_CAMERA: 'Curator - Opened camera panel',
  CURATOR_OPENED_PANEL_LIGHT: 'Curator - Opened light panel',
  CURATOR_OPENED_PANEL_IMAGES: 'Curator - Opened images panel',
  CURATOR_OPENED_PANEL_SETTINGS: 'Curator - Opened settings panel',
  CURATOR_OPENED_PANEL_METADATA: 'Curator - Opened metadata panel',
  CURATOR_OPENED_PANEL_AUTOMATION: 'Curator - Opened automation panel',
  CURATOR_OPENED_PANEL_EXCLUSIVE: 'Curator - Opened exclusive panel',
  CURATOR_OPENED_PANEL_MORE: 'Curator - Opened more panel',
  CURATOR_PANEL_RESIZED: 'Curator - Panel resized',
  CURATOR_PANEL_CLOSED: 'Curator - Panel closed',
  CURATOR_STYLE_EXPERT_MODE_ON: 'Curator - Expert mode on',
  CURATOR_STYLE_EXPERT_MODE_OFF: 'Curator - Expert mode off',
  CURATOR_BACKUP_USED: 'Curator - Backup used',
  CURATOR_BACKUP_CANCELED: 'Curator - Backup canceled',
  CURATOR_2D_TURNED_ON: 'Curator - 2D turned on',
  CURATOR_2D_TURNED_OFF: 'Curator - 2D turned off',
  CURATOR_PROP_ADDED: 'Curator - Prop added',
  CURATOR_PROP_REPLACED: 'Curator - Prop replaced',
  CURATOR_PROP_DUPLICATED: 'Curator - Prop duplicated',
  CURATOR_PROP_DELETED: 'Curator - Prop deleted',
  CURATOR_TEXTURE_ADDED: 'Curator - Texture added',
  CURATOR_MATERIAL_ADDED: 'Curator - Material added',
  CURATOR_MATERIAL_COPIED: 'Curator - Material copied',
  CURATOR_MATERIAL_PASTED: 'Curator - Material pasted',
  CURATOR_MOVE_SELECTED: 'Curator - Move tool selected',
  CURATOR_ROTATE_SELECTED: 'Curator - Rotate tool selected',
  CURATOR_SCALE_SELECTED: 'Curator - Scale tool selected',
  CURATOR_STYLE_SELECTED: 'Curator - Style only selected',
  CURATOR_PREVIEW_IMAGE_JOB_SENT: 'Curator - Preview image job sent',
  CURATOR_HIGH_RESOLUTION_IMAGE_JOB_SENT: 'Curator - High resolution image job sent',
  CURATOR_ROOM_SAVE: 'Curator - Room saved',
  CURATOR_ROOM_SAVED_AS_NEW: 'Curator - Room saved as new',
  CURATOR_LIVE_ON_APP: 'Curator - Live on app',
  CURATOR_CREATE_PROP_GROUP: 'Curator - Create product group',
  CURATOR_CAMERA_PRESET_IMPORTED: 'Curator - Camera preset imported',

  IMAGE_CURRENT_DOWNLOADED: 'Image - Current downloaded',
  IMAGE_ALL_DOWNLOADED: 'Image - All downloaded',

  SHARED_PROP: 'Shared - Prop',
  SHARED_TEXTURE: 'Shared - Texture',
  SHARED_TEMPLATE: 'Shared - Template',
  SHARED_PROJECT: 'Shared - Project',
  SHARED_COLLECTIONS: 'Shared - Collections',
  SHARED_IMAGE: 'Shared - Image',

  CURATOR_OPENED_PANEL_TILEGROUT: 'Curator - Opened TileGrout panel', // to be called whenever tile grout panel is opened
  CURATOR_TILEGROUT_PATTERN_SELECTED: 'Curator - TileGrout pattern selected', // to called when pattern is selected
  CURATOR_TILEGROUT_PATTERN_GENERATED: 'Curator - TileGrout pattern generated', // to be called when pattern gets generated
  CURATOR_TILEGROUT_PATTERN_SAVED: 'Curator - TileGrout pattern saved', // to be called when pattern gets saved

  // Product group events
  PG_VISITED: 'PG - Create Group - Clicked',
  PG_CREATED: 'PG - Created',
  PG_FILTER: 'PG - Filter Applied',
  PG_SHARE: 'PG - Shared',
  PG_USED: 'PG - Used in project',
  PG_ACCESS_REQUEST: 'PG - Request access',
  PG_REMOVE_ITEM: 'PG - Item removed',

  JOIN_DISCORD: 'Join Discord',
  JOIN_INSTAGRAM: 'Join Instagram',

  CLICK_UPLOAD_YOUR_FILES: 'Click - Upload your Files',
  CLICK_BROWSE_TEMPLATES: 'Click - Browse our templates',
  CLICK_INVITE_YOUR_TEAM: 'Click - Invite your team',
  CLICK_GENERATE_WITH_AI: 'Click - Generate with AI',
  CLICKED_AI_STUDIO: 'Clicked - AI Studio',
  CLICK_WORKFLOW_BUILDER: 'Click - Workflow Builder',
  CLICK_TEMPLATE_CATEGORY: 'Click - Template category',
  CLICK_TEXTURE: 'Click - Texture',
  CLICK_MODEL: 'Click - Model',
  CLICK_TEMPLATE: 'Click - Template',
  CLICK_TUTORIAL: 'Click - Tutorial',
  POPUP_UPLOAD_YOUR_FILE: 'Popup - Upload your file',
  FILE_UPLOAD_START: 'File upload start',
  FILE_UPLOAD_SUCCESS: 'File upload success',
  UPLOAD_LIMIT_REACHED_POPUP: 'Upload limit reached popup',

  POPUP_GENERATE_VISUAL: 'Popup - Generate visual',
  CLICK_GENERATE_VISUAL: 'Click - Generate visual',
  CLICK_EXPERIENCE_PRODUCT_SELECTED: 'Click - Experience product selected',
  CLICK_EXPERIENCE_PRODUCT_COMPONENT_SELECTION: 'Click - Experience product component selection',
  CLICK_SKIP_EXPERIENCE_CREATION: 'Click - Skip experience creation',
  VIEW_TEXTURE_EXPERIENCE_PAGE: 'View - Texture experience page',
  CLICK_CHANGE_PROP: 'Click - Change prop',
  CLICK_SAVE_ALL_AND_PROCEED: 'Click - Save all and proceed',
  EDIT_IN_3D_TEMPLATE: 'Edit in 3D Template',
  EDIT_IN_3D_PROJECT: 'Edit in 3D Project',
  EDIT_IN_3D_IMAGE: 'Edit in 3D Image',
  EDIT_IN_3D_AUTOMATION: 'Edit in 3D Automation',
  CLICK_GENERATE_DIMENSION: 'Click - Generate dimension shot',

  // public product page events
  PAGE_VIEWED: 'Page Viewed',
  EMAIL_SUBMITTED: 'Email Submitted',
  PRODUCT_IMAGE_VIEWED: 'Product Image Viewed',
  PRODUCT_ZOOMED: 'Product Zoomed',
  DOWNLOAD_ATTEMPTED: 'Download Attempted',
  CTA_CLICKED: 'CTA Clicked',
  CATEGORY_TAB_CLICKED: 'Category Tab Clicked',
  TIME_SPENT_ON_PAGE: 'Time Spent On Page',
};